/**
 * collection-sort-dropdown.js
 *
 * Works with the new-filter-wrapper / sorting--filter / layout--filter
 * structure in main-collection-product-grid.liquid.
 *
 * Upload to /assets/ and load with:
 *   <script src="{{ 'collection-sort-dropdown.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ── Sort dropdown ────────────────────────────────────────── */

  function initSortDropdown() {
    // Target the select inside .sorting--filter; fallback to any on page
    const allSelects = document.querySelectorAll(
      '.sorting--filter .facet-filters__sort, .facet-filters__sort'
    );

    // Deduplicate in case both selectors hit the same element
    const seen = new Set();
    const selects = Array.from(allSelects).filter(function (el) {
      if (seen.has(el)) return false;
      seen.add(el);
      return true;
    });

    selects.forEach(function (select) {
      const wrapper = select.closest('.facet-filters__field');
      if (!wrapper || wrapper.dataset.sortInit) return;
      wrapper.dataset.sortInit = 'true';

      // ── Build trigger button ──
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sort-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML =
        '<span class="sort-trigger__label">SORT</span>' +
        '<span class="svg-wrapper" aria-hidden="true">' +
        '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</span>';

      // ── Build dropdown panel ──
      const panel = document.createElement('ul');
      panel.className = 'sort-dropdown-panel';
      panel.setAttribute('role', 'listbox');

      Array.from(select.options).forEach(function (option) {
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        if (option.selected) li.classList.add('is-selected');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = option.text;
        btn.dataset.value = option.value;

        btn.addEventListener('click', function () {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          panel.querySelectorAll('li').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          li.classList.add('is-selected');
          closePanel();
        });

        li.appendChild(btn);
        panel.appendChild(li);
      });

      // ── Hide native select, inject custom UI ──
      select.style.display = 'none';
      wrapper.appendChild(trigger);
      wrapper.appendChild(panel);

      function openPanel() {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function closePanel() {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.classList.contains('is-open') ? closePanel() : openPanel();
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) closePanel();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
    });
  }

  /* ── Grid column toggle ───────────────────────────────────── */
  //
  // Mobile  (≤749px): buttons carry data-columns="1" or "2"
  //                   → toggles grid--N-col-tablet-down
  // Desktop (≥750px): buttons carry data-columns="2" or "4"
  //                   → toggles grid--N-col-desktop

  var MOBILE_BP = 989;

  function isMobile() {
    return window.innerWidth <= MOBILE_BP;
  }

  function colClass(cols) {
    return isMobile()
      ? 'grid--' + cols + '-col-tablet-down'
      : 'grid--' + cols + '-col-desktop';
  }

  function colPattern() {
    return isMobile()
      ? /\bgrid--\d-col-tablet-down\b/g
      : /\bgrid--\d-col-desktop\b/g;
  }

  function syncActiveButtons(grid) {
    document.querySelectorAll('.collection-grid-toggle [data-columns]')
      .forEach(function (b) {
        b.classList.toggle(
          'is-active',
          grid.classList.contains(colClass(b.dataset.columns))
        );
      });
  }

  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function initGridToggle() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const containers = document.querySelectorAll('.collection-grid-toggle');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.dataset.gridInit) return;
      container.dataset.gridInit = 'true';

      container.querySelectorAll('[data-columns]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const cols = btn.dataset.columns;

          // Swap the correct class family
          grid.className = grid.className.replace(colPattern(), '');
          grid.classList.add(colClass(cols));

          // Sync active state across all toggle containers
          syncActiveButtons(grid);
        });
      });
    });

    // Set initial active state
    syncActiveButtons(grid);

    // Re-sync when viewport crosses the breakpoint
    window.addEventListener('resize', debounce(function () {
      syncActiveButtons(grid);
    }, 200));
  }

  /* ── Bootstrap ────────────────────────────────────────────── */

  function init() {
    initSortDropdown();
    initGridToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify Ajax filter updates
  document.addEventListener('shopify:section:load', init);

})();